import { useAuth } from 'lib/auth';
import { useState, useEffect } from 'react';

export const useDevSettings = () => {
  const { user } = useAuth();
  // console.log(user)
  const loggedInUserStatus = user.status === 1 ? 'active' : 'inactive'
  // Helper function to read settings from localStorage
  const readSettings = () => {
    return {
      userStatus: localStorage.getItem('userStatus') || loggedInUserStatus || 'active',
      environment: localStorage.getItem('environment') || 'development',
      disableInactiveFeatures: localStorage.getItem('disableInactiveFeatures') === 'true',
    };
  };

  const [settings, setSettings] = useState(readSettings());

  useEffect(() => {
    const handleSettingsChange = () => {
      setSettings(readSettings());
    };

    // Listen to both storage events and our custom event.
    window.addEventListener('storage', handleSettingsChange);
    window.addEventListener('devSettingsUpdated', handleSettingsChange);

    return () => {
      window.removeEventListener('storage', handleSettingsChange);
      window.removeEventListener('devSettingsUpdated', handleSettingsChange);
    };
  }, []);

  return settings;
};
